module.exports = __webpack_public_path__ + "static/media/img_payment.39903a1c.png";